import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import * as React from "react";
import FormButton from "../../../../components/FormButton/FormButton";
import PlaidAuthenticator, {PlaidAuthenticationData} from "../../../../components/PlaidAuthenticator/PlaidAuthenticator";
import {formStores} from "../../state/mobx";
import {IGeneratePlaidAssetReportFuncParams} from "shared/functions/generatePlaidAssetReport";
import Loader from "../../../../components/Loader/Loader";
import * as queryString from "query-string";
import {RouteComponentProps} from "react-router";
import {IApplicationPath} from "../../../../../../shared/src/model/IApplication";

// @ts-ignore
import CHECKMARK from "../../../../assets/images/greenCheckMark.png";

interface IProps extends RouteComponentProps<any> {}


interface ILocalState {
    renderPlaidWindow: boolean,
    isPlaidConnectionFinished: boolean,
    isSending: boolean,
    errorFlag: boolean
}

const store = formStores.connectBankStore;
const ERROR_MESSAGE = "Connection failed. Try again or connect a different institution.";

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    formContainer: {
        textAlign: "center",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    header: {
        fontSize: 19,
        fontWeight: "bold",
        color: "#305cc6",
        marginBottom: "1em"
    },
    subHeader: {
        fontSize: 16,
        fontWeight: 300,
        color: "#2f3033",
        marginBottom: "1em"
    },
    checkmarkImg: {
        height: "3em",
        width: "3em",
        margin: "1em auto"
},
    formSuccessHeader: {
        fontSize: 15,
        fontWeight: "bold",
        color: "#2f3033",
        marginBottom: "1em"
    },
    formSuccessSubHeader: {
        fontSize: 15,
        fontWeight: 500,
        color: "#2f3033",
        marginBottom: "1em"

    },
    formSuccessSubLink: {
        fontWeight: 600,
        color: "#305cc6"
    },
    error: {
        fontSize: 12,
        fontWeight: 500,
        color: "#e96767",
        marginTop: ".5em"
    }
});

@(withStyles(styles) as any)
export default class FormConnectBank extends React.Component<
    IProps & Partial<WithStyles<any>>, ILocalState
    > {

    public state: ILocalState = {
        renderPlaidWindow: false,
        isPlaidConnectionFinished: false,
        isSending: false,
        errorFlag: false
    };

    public render() {
        const {isPlaidConnectionFinished, isSending} = this.state;
        {return isSending? <Loader/> : isPlaidConnectionFinished? this.renderFormSubmittedSuccessfully(): this.renderConnectionForm()}
    }

    private renderFormSubmittedSuccessfully = () => {
        const { classes } = this.props;
        return (
            <div className={classes!.formContainer}>
                <img className={classes!.checkmarkImg} src={CHECKMARK}/>
                <div className={classes!.formSuccessHeader}>Your bank account is now connected</div>
                <div className={classes!.formSuccessSubHeader}>Information is being processed.<br/> We'll be in touch shortly.</div>
                <div className={classes!.formSuccessSubLink}>www.salaryo.com</div>
            </div>
        )
    };

    private renderConnectionForm = () => {
        const { classes } = this.props;
        const {errorFlag} = this.state;
        return (<div className={classes!.formContainer}>
            {this.renderPlaid()}
            <div className={classes!.header}>Please plug in your financials</div>
            <div className={classes!.subHeader}>Encrypted, private and secured connection</div>
            <FormButton btnText={"Connect bank"} classes={"yellow"} click={this.connectBank}/>
            {errorFlag? <div className={classes!.error}>{ERROR_MESSAGE}</div>: null}
        </div>);
    };

    private renderPlaid = () => {
        const {renderPlaidWindow} = this.state;
        return renderPlaidWindow ? <PlaidAuthenticator onConnectExit={this.closePlaid} onAuthenticationFinished={this.onAuthenticationFinished}/> : null
    };

    private closePlaid = () => {
        const newState = this.state;
        newState.renderPlaidWindow = false;
        this.setState(newState);
    };

    private onAuthenticationFinished = async (succeeded: boolean, data?: PlaidAuthenticationData) => {
        this.updateLoader(true);
        if(succeeded && data) {
            this.handlePlaidData(data);
        }else {
            this.updateLoader(false);
            const newState = this.state;
            newState.errorFlag = true;
            this.setState(newState);
        }
    };

    private connectBank = () => {
        const newState = this.state;
        newState.renderPlaidWindow = true;
        this.setState(newState);
    };

    private updateLoader = (val: boolean) => {
        const newState = this.state;
        newState.isSending = val;
        this.setState(newState);
    };

    private getApplicationInfo = (): IApplicationPath => {
        return queryString.parse(this.props.location.search);
    }

    private handlePlaidData = async (data: PlaidAuthenticationData) => {
        const params: IGeneratePlaidAssetReportFuncParams = {
            bankInfo: data,
            userData: this.getApplicationInfo()
        };
        const response = await store.sendPlaidData(params);
        this.updateLoader(false);
        const newState = this.state;
        if (response.ok) {
            newState.isPlaidConnectionFinished = true;
            newState.renderPlaidWindow = false;
        } else {
            newState.renderPlaidWindow = false;
            newState.errorFlag = true;
        }
        this.setState(newState);
    }
};


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormConnectBank/FormConnectBank.tsx